export const swimmersSelector = state => state.coach.swimmers